import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Typography,
  makeStyles,
  Button,
  Paper,
  Grid,
} from "@material-ui/core";
import Page from "src/components/Page";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import { Alert } from "@material-ui/lab";
import { kmMessages, getSystemLabel } from "src/constant/Messages";
import { apiEndpoints, apiGetRequest, apiPostRequest } from "src/utils/api/api";
import { useNavigate } from "react-router-dom";
import Licence from "src/components/common/Licence";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingBottom: theme.spacing(1),
    paddingTop: theme.spacing(1),
  },
  massagebox: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  lcontent: {
    fontSize: 11,
  },
  img: {
    margin: "auto",
    display: "block",
    [theme.breakpoints.up("lg")]: {
      maxWidth: "42%",
    },
    [theme.breakpoints.down("lg")]: {
      maxWidth: "52%",
    },
    [theme.breakpoints.down("md")]: {
      maxWidth: "70%",
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: "95%",
    },
    maxHeight: "100%",
  },
}));

const LicenseView = ({
  globalData,
  setAuthorized,
  setCurrentUserData,
  enableGlobalLoader,
  disableGlobalLoader,
  displaySnackbar,
  setLogoutUser,
}) => {
  const classes = useStyles();
  const navigate = useNavigate();

  const acceptLicence = () => {
    enableGlobalLoader();

    apiPostRequest(apiEndpoints.setConsent.path, { action: "licence" }, true)
      .then((data) => {
        disableGlobalLoader();
        apiGetRequest(apiEndpoints.getLoggedUser.path, true)
          .then((data) => {
            disableGlobalLoader();
            setAuthorized(true);
            setCurrentUserData(data);
            navigate("/");
          })
          .catch((error) => {
            disableGlobalLoader();
            if (error.response) {
              if (error.response.status === 403) {
                if (error.response.data) {
                  if (error.response.data.code === "POLICY_NOT_ACCEPTED") {
                    navigate("/politykabezp");
                    return;
                  }
                }
              }
            }
            displaySnackbar({
              isOpen: true,
              severity: "error",
              autoHideDuration: 10000,
              message: kmMessages.error.global.apierror,
            });
            setLogoutUser();
          });
      })
      .catch((error) => {
        disableGlobalLoader();
        displaySnackbar({
          isOpen: true,
          severity: "error",
          autoHideDuration: 10000,
          message: kmMessages.error.global.apierror,
        });
        setLogoutUser();
      });
  };

  const noAcceptLicence = () => {
    setLogoutUser();
  };

  return (
    <Page className={classes.root} title="Licencja">
      <Container maxWidth="lg">
        <Box
          display="flex"
          flexWrap="wrap"
          alignContent="center"
          p={1}
          css={{ height: "4vh" }}
        ></Box>
        <Box
          display="flex"
          flexDirection="column"
          height="100%"
          justifyContent="center"
        >
          <Box mb={1}>
            {getSystemLabel("programLicenseAccept", globalData.systemInfo) ? (
              <Alert severity="info" className={classes.massagebox}>
                <div>{getSystemLabel("programLicenseAccept", globalData.systemInfo)}</div>
              </Alert>
            ) : (
              <></>
            )}
            <Paper>
              <Licence></Licence>
            </Paper>
            <Box>
              <Paper>
                <Box mt={1} p={1}>
                  <Typography component="p" display="block">
                    Czy akceptujesz warunki licencji określającej pola
                    eksploatacji aplikacji Portal Komitetu Monitorującego{" "}
                    {getSystemLabel("program", globalData.systemInfo)} (Portal
                    KM{" "}
                    {getSystemLabel("programShortcut", globalData.systemInfo)})?
                  </Typography>
                </Box>
              </Paper>
            </Box>

            <Box my={2}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Paper className={classes.paper}>
                    <Button
                      color="primary"
                      fullWidth
                      size="large"
                      onClick={noAcceptLicence}
                    >
                      Nie
                    </Button>
                  </Paper>
                </Grid>
                <Grid item xs={6}>
                  <Paper className={classes.paper}>
                    <Button
                      color="primary"
                      fullWidth
                      size="large"
                      variant="contained"
                      onClick={acceptLicence}
                    >
                      Tak
                    </Button>
                  </Paper>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
      </Container>
      <Box display="flex" alignItems="flex-end" flexGrow={1} p={1}>
        <Box display="flex" flexDirection="column">
          <img
            className={classes.img}
            alt="Logo UE stopka"
            src="/static/images/logo_ue_main.jpg"
          />
          <Typography
            variant="caption"
            gutterBottom
            color="textSecondary"
            align="center"
            component="p"
          >
            Aplikacja współfinansowana przez Unię Europejską ze środków
            Europejskiego Funduszu Społecznego w ramach Regionalnego Programu
            Operacyjnego Województwa Podlaskiego na lata 2014-2020
          </Typography>
          <Typography
            color="textPrimary"
            variant="subtitle2"
            align="center"
            component="p"
          >
            2021 © Urząd Marszałkowski Województwa Podlaskiego
          </Typography>
        </Box>
      </Box>
    </Page>
  );
};

const mapStateToProps = (state) => ({
  globalData: state.globalData,
});

const mapDispatchToProps = (dispatch) => ({
  setAuthorized: (isAuthorized) =>
    dispatch(actions.setAuthorized(isAuthorized)),
  setCurrentUserData: (currentUserData) =>
    dispatch(actions.setCurrentUser(currentUserData)),
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
  displaySnackbar: (snackBarParameters) =>
    dispatch(actions.displaySnackbar(snackBarParameters)),
  setLogoutUser: () => dispatch(actions.setLogoutUser()),
});

export default connect(mapStateToProps, mapDispatchToProps)(LicenseView);
